export default {"src":"/_next/static/media/list-icon.70325e21.svg","height":15,"width":23};